import { darken } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.nav`
  margin-bottom: 60px;
  max-width: 100%;
`

export const Nav = styled.div`
  z-index: ${({ theme }) => theme.zIndexes.hard};

  top: 0;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;

  padding: 0 10%;
  transition: ${({ theme }) => theme.transitions('padding')};

  background: ${({ theme, isHovered }) => (isHovered ? darken(0.3, theme.colors.primary) : theme.colors.whiteDark)};
  color: ${({ theme, isHovered }) => (isHovered ? theme.colors.whiteDark : theme.colors.blackWhite)};
  transition: ${({ theme }) => theme.transitions('background-color')};

  @media screen and (max-width: 700px) {
    padding: 0;
    justify-content: space-around;
    background: ${({ theme }) => darken(0.3, theme.colors.primary)};
    color: ${({ theme }) => theme.colors.whiteDark};
  }
`

export const Section = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 700px) {
    width: 100%;
    display: ${({ hidenOnMobile }) => (hidenOnMobile ? 'none' : 'flex')};
    justify-content: space-around;
    font-size: 0.8em;
  }
`

export const NavItem = styled.div`
  cursor: pointer;
  padding: 4px 20px;
  border-bottom: solid 2px transparent;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: ${({ theme }) => theme.transitions(['background-color', 'color'])};

  border-bottom: solid 2px ${({ theme, active }) => (active ? theme.colors.primary : 'transparent')};

  & > svg {
    width: 30px;
  }

  &:hover {
    border-bottom: solid 2px ${({ theme }) => theme.colors.whiteDark};
  }

  @media screen and (max-width: 700px) {
    padding: 4px 10px;
  }
`

export const SubNav = styled.div`
  position: fixed;
  z-index: ${({ theme }) => theme.zIndexes.base};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 70px;

  background: ${({ theme }) => darken(0.2, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.white};
  transition: ${({ theme }) => theme.transitions('background-color')};

  opacity: ${({ active }) => (active ? 1 : 0)};
  height: ${({ active }) => (active ? '40px' : '0px')};
  transition: ${({ theme }) => theme.transitions('opacity')};
`

export const SubNavItem = styled.div`
  cursor: pointer;
  padding: 0 10px;

  &:hover {
    opacity: 0.8;
    transition: ${({ theme }) => theme.transitions('opacity')};
  }
`
